import { HttpContextToken } from '@angular/common/http';

export const apiHideErrorToastContext = new HttpContextToken<boolean>(
  () => false,
);
